import { render } from "./CommodityList.vue?vue&type=template&id=3ee59b5a&scoped=true"
import script from "./CommodityList.vue?vue&type=script&lang=js"
export * from "./CommodityList.vue?vue&type=script&lang=js"

import "./CommodityList.vue?vue&type=style&index=0&id=3ee59b5a&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ee59b5a"]])

export default __exports__